var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a-layout',{staticClass:"layout"},[_c('layout-header'),_c('layout-content')],1)}
var staticRenderFns = []

export { render, staticRenderFns }